import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/hasPermission";
import { PERM } from "../../utils/permissions";
import Header from "../common/Header";
import ContractRegistration from "./ContractRegistration";
import ProjectAssign from "./ProjectAssign";

export default function ProjectSetup() {
  const userInfo = useSelector((state) => state.userInfo);
  const canContractReg = hasPermission(userInfo.permissions, PERM.PRJ_CONTRACT_REG);

  const [cMenu, setCMenu] = useState(canContractReg ? "contrReg" : "prjAsgmt");

  const [menuDataSource, setMenuDataSource] = useState(null);
  
  useEffect(() => {
    const menu = canContractReg
      ? [
          { id: "contrReg", name: "CONTRACT REGISTRATION", selected: true },
          { id: "prjAsgmt", name: "PROJECT ASSIGN" },
        ]
      : [
          { id: "contrReg", name: "CONTRACT REGISTRATION", disabled: true },
          { id: "prjAsgmt", name: "PROJECT ASSIGN", selected: true },
        ];
    setMenuDataSource(menu);
  }, []);

  return (
    <React.Fragment>
      <Header
        title={"PROJECT SETUP"}
        menuDataSource={menuDataSource}
        setCMenu={setCMenu}
      />
      <div style={{ margin: "40px auto", width: "95vw" }}>
        {cMenu == "contrReg" && <ContractRegistration />}
        {cMenu == "prjAsgmt" && <ProjectAssign />}
      </div>
    </React.Fragment>
  );
}
